import { Button, Grid } from '@mui/material';

import React, { useState } from 'react';

import Viewpayer from './Viewpayer';

function Payer() {
	return (
		<Grid container>
			<Grid item xs={12} lg={12} xl={12}>
				<Viewpayer />
			</Grid>
		</Grid>
	);
}

export default Payer;
